import { NavLink } from "react-router-dom";
import { getUser } from "../../../config/auth";

function TacklLogoMark({ size = 34 }) {
  return (
    <img
      src="/logo.svg"
      alt="Tackl"
      style={{ width: size, height: size, objectFit: "contain", flexShrink: 0 }}
    />
  );
}

function Icon({ name }) {
  const s = { width: 16, height: 16, style: { flexShrink: 0 } };
  const p = { stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };

  switch (name) {
    case "apps":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <rect x="3" y="3" width="7" height="7" rx="1.5" {...p} />
          <rect x="14" y="3" width="7" height="7" rx="1.5" {...p} />
          <rect x="3" y="14" width="7" height="7" rx="1.5" {...p} />
          <rect x="14" y="14" width="7" height="7" rx="1.5" {...p} />
        </svg>
      );
    case "dashboard":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M4 13h7V4H4v9z" {...p} />
          <path d="M13 20h7V4h-7v16z" {...p} />
          <path d="M4 20h7v-5H4v5z" {...p} />
        </svg>
      );
    case "employees":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...p} />
          <circle cx="9" cy="7" r="4" {...p} />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" {...p} />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" {...p} />
        </svg>
      );
    case "attendance":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="17" rx="2" {...p} />
          <path d="M8 2v4" {...p} />
          <path d="M16 2v4" {...p} />
          <path d="M3 10h18" {...p} />
          <path d="m8 15 2 2 5-5" {...p} />
        </svg>
      );
    case "leaves":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M6 3h12l3 5v13H3V8l3-5z" {...p} />
          <path d="M6 3v5h15" {...p} />
          <path d="M8 14h8" {...p} />
          <path d="M8 18h5" {...p} />
        </svg>
      );
    default:
      return null;
  }
}

function RailLink({ to, label, icon, onClick }) {
  return (
    <NavLink
      to={to}
      title={label}
      aria-label={label}
      className={({ isActive }) => `sidebar-rail-item${isActive ? " active" : ""}`}
      onClick={onClick}
    >
      <Icon name={icon} />
    </NavLink>
  );
}

function SidebarLink({ to, label, icon, onClick }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) => `sidebar-item${isActive ? " active" : ""}`}
      onClick={onClick}
    >
      <Icon name={icon} />
      <span>{label}</span>
    </NavLink>
  );
}

function SidebarSection({ label }) {
  return (
    <div className="sidebar-section-row">
      <span className="sidebar-section">{label}</span>
    </div>
  );
}

export default function HrmsSidebar({ isOpen, onClose }) {
  const user = getUser();
  const role = user?.role || "Staff";
  const initial = (user?.name || user?.email || "?")[0].toUpperCase();

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

      <aside className={`sidebar hrms-sidebar${isOpen ? " sidebar--open" : ""}`}>
        <div className="sidebar-primary-rail" aria-label="HRMS primary navigation">
          <div className="sidebar-rail-logo">
            <TacklLogoMark size={30} />
          </div>
          <nav className="sidebar-rail-nav">
            <RailLink to="/hrms/dashboard" label="HRMS Dashboard" icon="dashboard" onClick={onClose} />
          </nav>
        </div>

        <div className="sidebar-panel">
          <div className="sidebar-header">
            <div className="sidebar-brand">
              <div>
                <div className="sidebar-title">HRMS Workspace</div>
                <div className="sidebar-subtitle">People operations</div>
              </div>
            </div>
            <button className="sidebar-close-btn" onClick={onClose} aria-label="Close menu">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <nav className="sidebar-nav">
            <SidebarSection label="HRMS" />
            <SidebarLink to="/hrms/dashboard" label="Dashboard" icon="dashboard" onClick={onClose} />
            <SidebarLink to="/hrms/employees" label="Employees" icon="employees" onClick={onClose} />

            <SidebarSection label="Operations" />
            <SidebarLink to="/hrms/attendance" label="Attendance" icon="attendance" onClick={onClose} />
            <SidebarLink to="/hrms/leaves" label="Leave Requests" icon="leaves" onClick={onClose} />
          </nav>

          <div className="sidebar-footer">
            <div className="sidebar-user-row">
              <div className="sidebar-user-avatar">{initial}</div>
              <div className="sidebar-user-info">
                <div className="sidebar-user-name">
                  {user?.name || user?.email?.split("@")[0] || "User"}
                </div>
                <div className="sidebar-user-role">{role}</div>
              </div>
              <span className="sidebar-beta-badge">HRMS</span>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
